import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useLogout from "../Hooks/useLogout";
import useAuth from "../Hooks/auth/useAuth";
import Loader from "../Components/Loader";
import axiosDotnet from "../services/axiosDotnet";
import timeAgo from "../services/timeAgo"
import { showError, showSuccess, showWarning } from "../services/reactToastify";
import Select from 'react-select';

export default function Dashboard() {
    const { auth } = useAuth();
    const Logout = useLogout();
    const [loading, setLoading] = useState(false);
    const [workSpaces, setWorkSpaces] = useState([]);
    const [filteredWorkspaces, setFilteredWorkspaces] = useState([]);
    const [error, setError] = useState('');
    const navigate = useNavigate()
    const [filter, setFilter] = useState("AllWorkspaces"); 
    const [searchId, setSearchId] = useState('');

    useEffect(() => {
        async function fetchWorkspaces() {
            setLoading(true);
            try {
                const response = await axiosDotnet.get('/api/workspaces');
                // console.log('Workspaces fetched:', response?.data);
                setWorkSpaces(response?.data);
            } catch (err) {
                // console.log(auth)
                // console.error(err?.response);
                // showError(err?.response?.data?.message || 'Failed to fetch workspaces');
            } finally {
                setLoading(false);
            }
        };

        if (auth?.foundUser?.id) {
            fetchWorkspaces();
        }

    }, [auth?.foundUser?.id])

    useEffect(() => {
        let result = [...workSpaces];

        if (filter === "Joined") {
            result = result.filter(ws => ws.status === "APPROVED");
        } else if (filter === "RequestPending") {
            result = result.filter(ws => ws.status === "PENDING");
        } else if (filter === "AllWorkspaces") {
            result = result;
        } else if (filter === "NotJoined") {
            result = result.filter(ws => ws.status !== "PENDING" && ws.status !== "APPROVED");
        } else if (filter === "MyWorkspaces") {
            result = result.filter(ws => ws.roleInWorkspace === "ADMIN");
        } else if (filter === "OthersWorkspaces") {
            result = result.filter(ws => ws.roleInWorkspace !== "ADMIN");
        }


        setFilteredWorkspaces(result);
    }, [workSpaces, filter]);

    const handleJoin = async (wId) => {

        if (!auth?.foundUser?.id) {
            setError('User not authenticated. Please login again.');
            return;
        }

        setError('');
        setLoading(true);

        try {
            // console.log(workspaceName, description)
            const response = await axiosDotnet.post(`/api/workspaces/${wId}/members/join`);
            // console.log('req sent:', response.data);
            showSuccess('Joining Request sent successfully!');
            window.location.reload()

        }
        catch (err) {
            console.error(err?.response);
            showError(
                err?.response?.data?.message ||
                err?.response?.data ||
                'Failed to join workspace. Please try again.'
            );
        }
        finally {
            setLoading(false);
        }
    };

    const filterOptions = [
        { value: "AllWorkspaces", label: "All Workspaces" },
        { value: "Joined", label: "Joined Workspaces" },
        { value: "RequestPending", label: "Pending Requests" },
        { value: "NotJoined", label: "Workspaces Not Joined" },
        { value: "MyWorkspaces", label: "My Workspaces" },
        { value: "OthersWorkspaces", label: "Others' Workspaces" }
    ];

    const handleDeleteWorkspace = async (workspaceId) => {
        if (!window.confirm("Are you sure you want to delete this workspace?")) return;

        try {
            await axiosDotnet.delete(`/api/workspaces/${workspaceId}`);
            showSuccess("Workspace deleted successfully");
            window.location.reload();
        } catch (err) {
            showError("Failed to delete workspace");
        }
    };

    return (
        <div className=" overflow-hidden ">
            {!auth || auth === undefined || auth === null || loading ? (
                <Loader text="Loading Your Workspaces..." />
            ) : (
                <div className="bg-zinc-950 text-white font-sans min-h-screen overflow-auto custom-scrollbar">
                    {/* ==================== NAVBAR ==================== */}
                    <nav className="fixed top-0 left-0 right-0 z-50 bg-zinc-950/80 backdrop-blur-lg border-b border-zinc-800">
                        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
                            <div className="flex items-center gap-3 cursor-pointer">
                                <div className="w-8 h-8 bg-violet-900 rounded-xl flex items-center justify-center text-white font-bold text-xl">A</div>
                                <span className="text-2xl font-semibold tracking-tight">AetherForge</span>
                            </div>

                            {/* Name + Role - Optimized Styling */}
                            <div className="flex items-center gap-4">
                                <div className="text-right">
                                    <p className="text-white font-medium text-lg">
                                        {auth?.foundUser?.name || "User"}
                                    </p>
                                    {/* {auth?.foundUser?.roles && auth.foundUser.roles.length > 0 && (
                                        <div className="flex gap-2 justify-end">
                                            {auth.foundUser.roles.map((role, index) => (
                                                <span
                                                    key={index}
                                                    className="px-3 py-1 text-xs font-medium bg-violet-900/80 text-violet-300 rounded-full border border-violet-700"
                                                >
                                                    {role}
                                                </span>
                                            ))}
                                        </div>
                                    )} */}
                                </div>

                                <button
                                    onClick={Logout}
                                    className="px-6 cursor-pointer py-2 bg-white text-zinc-900 rounded-2xl font-semibold hover:bg-violet-500 hover:text-white transition-all"
                                >
                                    Logout
                                </button>
                            </div>
                        </div>
                    </nav>

                    {/* ==================== MAIN CONTENT ==================== */}
                    <div className="pt-24 pb-16 ">
                        <div className="max-w-7xl mx-auto px-6 ">
                            {/* Header + Create Button - Mobile Optimized */}
                            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
                                <div>
                                    <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter">
                                        All Workspaces
                                    </h1>
                                    <p className="text-zinc-400 text-lg sm:text-xl mt-2">
                                        Join collaborative spaces • AI-powered teams • Real-time projects
                                    </p>
                                </div>
                                <div className="flex items-center gap-4">

                                 

                                    <Link
                                        to="/createWorkspace"
                                        className="w-full sm:w-auto px-6 sm:px-8 py-4 bg-violet-900 hover:bg-violet-600 transition-all rounded-3xl font-semibold flex items-center justify-center gap-3 text-base sm:text-lg shadow-lg shadow-violet-500/20"
                                    >
                                        <span>Create New Workspace</span>
                                        <span className="text-3xl leading-none mt-px">+</span>
                                    </Link>
                                </div>
                            </div>
                            <div className="flex justify-start mx-3 my-6">
                                <div className="w-[40%]">
                                <input
                                    type="text"
                                    placeholder="Search by Workspace ID..."
                                    value={searchId}
                                    onChange={(e) => setSearchId(e.target.value)}
                                    className="bg-zinc-900 border border-zinc-700 rounded-3xl px-5 py-4 text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-violet-500 w-full sm:w-[260px]"
                                />
                                </div>
                                <div className="flex gap-3 items-center">
                                    {/* Filter Workspace: */}
                                   <Select
                                        value={filterOptions.find(option => option.value === filter)}
                                        onChange={(selected) => setFilter(selected.value)}
                                        options={filterOptions}
                                        className="w-full sm:w-[260px]"
                                        classNamePrefix="select"
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary: '#8b5cf6',           // Violet accent
                                                primary25: '#4c1d95',
                                                neutral0: '#18181b',          // Background
                                                neutral10: '#27272a',         // Border
                                                neutral80: '#ffffff',         // Main Text (White)
                                                neutral70: '#e4e4e7',         // Secondary Text
                                            },
                                        })}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                backgroundColor: '#18181b',
                                                borderColor: '#3f3f46',
                                                color: '#ffffff',
                                                borderRadius: '9999px',
                                                padding: '4px 8px',
                                                minHeight: '48px',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: '#6b7280',
                                                },
                                                cursor: "pointer"
                                            }),

                                            singleValue: (base) => ({
                                                ...base,
                                                color: '#ffffff',
                                                fontWeight: '500',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected ? '#4c1d95' : '#18181b',
                                                color: '#e4e4e7',
                                                '&:hover': {
                                                    backgroundColor: '#27272a',
                                                },
                                                cursor: "pointer"
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                backgroundColor: '#18181b',
                                                border: '1px solid #3f3f46',
                                                borderRadius: '16px',
                                                marginTop: '8px',

                                            }),
                                        }}
                                    />
                                    </div>
                            </div>
                            {/* Workspaces Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 ">
                                {filteredWorkspaces.length > 0 &&
                                    filteredWorkspaces?.filter(ws => (searchId == '' && ws) || ws?.id == searchId)
                                                       .map((workspace) => (
                                        <div
                                            key={workspace?.id}
                                            // to={`/workspace/${workspace?.id}`}
                                            className="group bg-zinc-900 border border-zinc-800 hover:border-violet-500 rounded-3xl p-8 transition-all hover:shadow-2xl hover:-translate-y-1"
                                        >
                                            <div className="flex items-start justify-between mb-6">
                                                <div className="flex items-center gap-4">
                                                    <div className="w-12 h-12 bg-gradient-to-br from-violet-500 to-violet-700 rounded-2xl flex items-center justify-center text-3xl font-bold shadow-inner">
                                                        {workspace?.name[0]}
                                                    </div>
                                                    <div>
                                                        <h3 className="text-2xl font-semibold tracking-tight group-hover:text-violet-300 transition-colors">
                                                            {workspace?.name}
                                                        </h3>

                                                        <p className="text-xs text-emerald-400 font-medium flex items-center gap-1">
                                                            <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></span>
                                                            {/* {workspace?.status === "APPROVED" && workspace?.roleInWorkspace !== "ADMIN" && <span className="mr-2">MEMBER</span>} */}
                                                            {(workspace?.status === "APPROVED") && workspace?.roleInWorkspace}
                                                            {workspace?.status === "PENDING" && <span className="text-amber-400">(Request Pending)</span>}

                                                        </p>
                                                    </div>
                                                    {(workspace?.status !== "PENDING" && workspace?.status !== "APPROVED") && (<button
                                                        onClick={() => handleJoin(workspace?.id)}
                                                        className="cursor-pointer w-full sm:w-auto px-3 sm:px-5 py-3 bg-violet-900 hover:bg-violet-600 transition-all rounded-3xl">
                                                        <h5 className="text-xl font-semibold tracking-tight group-hover:text-violet-300 transition-colors">
                                                            Join
                                                        </h5>
                                                    </button>)}

                                                </div>
                                            </div>

                                            <p className="text-zinc-400 text-sm leading-relaxed line-clamp-3 mb-2">
                                                <span className="text-emerald-500">WS_Id:</span> {workspace?.id}
                                            </p>

                                            <p className="text-zinc-400 text-sm leading-relaxed line-clamp-3 mb-8">
                                                {workspace?.description}
                                            </p>

                                            <div className="grid grid-cols-3 gap-4 text-center border-t border-zinc-800 pt-6">
                                                <div>
                                                    <div className="text-3xl font-bold text-violet-400">{workspace?.projectsCount}</div>
                                                    <div className="text-xs text-zinc-500 tracking-widest">PROJECTS</div>
                                                </div>
                                                <div>
                                                    <div className="text-3xl font-bold text-emerald-400">{workspace?.membersCount}</div>
                                                    <div className="text-xs text-zinc-500 tracking-widest">MEMBERS</div>
                                                </div>
                                                <div>
                                                    <div className="text-3xl font-bold text-amber-400">{workspace?.tasksCount}</div>
                                                    <div className="text-xs text-zinc-500 tracking-widest">TASKS</div>
                                                </div>
                                            </div>

                                            <div
                                                onClick={() => {
                                                    // const isApproved = workspace?.members?.some(m =>
                                                    //     m.userId === auth?.foundUser.id && m?.status === "APPROVED"
                                                    // );
                                                    // console.log(isApproved)
                                                    if (workspace?.status === "APPROVED") {
                                                        navigate(`/workspace/${workspace?.id}`)
                                                    }
                                                    else {
                                                        showWarning("You don't have access to this workspace, get approved from admin first ");
                                                    }
                                                }}
                                                className="mt-8 cursor-pointer flex items-center justify-between text-xs">
                                                <div className="text-zinc-400">
                                                    Last active <span className="font-medium text-white">{timeAgo(workspace?.lastActive)}</span>
                                                </div>
                                                <div

                                                    className="flex items-center gap-2 text-violet-400 text-sm font-medium">
                                                    Open Workspace
                                                    <span className="text-xl leading-none">→</span>
                                                </div>
                                            </div>

                                            {/* Action Buttons - Update & Delete (Admin Only) */}
                                            {workspace?.roleInWorkspace === "ADMIN" && workspace?.status === "APPROVED" && (
                                                <div className="flex gap-3 mt-8">
                                                    <button
                                                        onClick={() => navigate(`/updateWorkspace/${workspace?.id}`)}
                                                        className="cursor-pointer flex-1 py-3 text-sm font-medium border border-zinc-600 hover:bg-zinc-800 rounded-2xl transition-all"
                                                    >
                                                        ✏️ Update
                                                    </button>

                                                    <button
                                                        onClick={() => handleDeleteWorkspace(workspace?.id)}
                                                        className="cursor-pointer flex-1 py-3 text-sm font-medium border border-red-600 hover:bg-red-900/30 text-red-400 rounded-2xl transition-all"
                                                    >
                                                        🗑️ Delete
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <footer className="bg-zinc-950 border-t border-zinc-800 py-12">
                        <div className="max-w-7xl mx-auto px-6 text-zinc-400 text-sm">
                            <p className="text-center">© 2026 AetherForge • All rights reserved</p>
                        </div>
                    </footer>
                </div>
            )}
        </div>
    );
}


// import { formatDistanceToNow } from 'date-fns';
// const formatted = formatDistanceToNow(new Date("2026-04-29T19:21:30.908111Z"), { addSuffix: true });
